import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultFooterComponent } from './components/default-footer/default-footer.component';
import { Common2Module } from 'projects/common/src/app/app.module';

@NgModule({
  declarations: [
    DefaultFooterComponent
  ],
  imports: [
    CommonModule,
    Common2Module.forRoot()
  ],
  exports: [
    DefaultFooterComponent
  ]
})
export class FooterModule { }
